import { DELIVERY_MODE } from "constants/moduleConstants/projectInfo.constant";

/**
 * Filter projects for a delivery mode tab.
 * Projects without deliveryMode appear in both tabs.
 */
export const filterProjectsByDeliveryMode = (projects, activeMode) => {
  return projects.filter((project) => {
    const mode = project.projectinfo?.deliveryMode;
    if (!mode) return true;
    return mode === activeMode;
  });
};

export const getProjectInitials = (name) => {
  if (!name) return "?";
  const parts = String(name).trim().split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[1][0]).toUpperCase();
  }
  return parts[0].slice(0, 2).toUpperCase();
};

export const getProjectLocationText = (project, activeMode) => {
  const info = project.projectinfo;
  if (!info) return project.desc || "";

  if (info.deliveryMode === DELIVERY_MODE.BIN || activeMode === DELIVERY_MODE.BIN) {
    return info.address || project.desc || "";
  }

  return info.infoText || project.desc || "";
};

export default filterProjectsByDeliveryMode;
